import type { BigDecimal } from '@0xtorch/big-decimal'

export const taxTypes = [
  'taxable',
  'non-taxable',
  'excluded',
  'export-exempt',
] as const
export type TaxType = (typeof taxTypes)[number]

/** 仕訳の単一科目 / + の際に借方 / - の際に貸方 */
export type JournalEntryUnit = {
  readonly key: string
  readonly transactionId: string
  /** 日付 | YYYY/MM/DD */
  readonly date: string
  /** 勘定科目 */
  readonly account: string
  /** 補助科目 */
  readonly subAccount: string
  /** 金額 */
  readonly amount: BigDecimal
  /** 借方税区分 */
  readonly debitTaxType: TaxType
  /** 貸方税区分 */
  readonly creditTaxType: TaxType
  /** action sources */
  readonly sources: Set<string>
}

export type JournalEntrySideCells = {
  readonly account: string
  readonly subAccount: string
  readonly amount: string
  readonly taxType: TaxType
}

export type JournalEntry = {
  /** 日付 | YYYY/MM/DD */
  readonly date: string
  /** 借方 */
  readonly debits: readonly JournalEntrySideCells[]
  /** 貸方 */
  readonly credits: readonly JournalEntrySideCells[]
  /** コメント */
  readonly comment: string
}

export type JournalAccount = {
  readonly account: string
  readonly subAccount: string
  readonly debitTaxType: TaxType
  readonly creditTaxType: TaxType
}

export type JournalAccountConfig = {
  readonly cash: JournalAccount
  readonly crypto: JournalAccount
  readonly 'restricted-crypto': JournalAccount
  readonly 'payment-instrument': JournalAccount
  readonly nft: JournalAccount
  readonly 'borrowed-crypto': JournalAccount
  readonly 'borrowed-payment-instrument': JournalAccount
  readonly 'lent-crypto': JournalAccount
  readonly 'lent-payment-instrument': JournalAccount
  readonly 'borrowed-nft': JournalAccount
  readonly 'lent-nft': JournalAccount
  readonly fee: JournalAccount
  readonly 'bridge-fee': JournalAccount
  readonly 'interest-fee': JournalAccount
  readonly 'tx-fee': JournalAccount
  readonly 'other-fee': JournalAccount
  readonly pay: JournalAccount
  readonly burn: JournalAccount
  readonly stolen: JournalAccount
  readonly 'derivative-fee': JournalAccount
  readonly 'liquidation-loss': JournalAccount
  readonly 'realize-loss': JournalAccount
  readonly 'transfer-loss': JournalAccount
  readonly income: JournalAccount
  readonly 'nft-royalty': JournalAccount
  readonly gift: JournalAccount
  readonly 'other-income': JournalAccount
  readonly airdrop: JournalAccount
  readonly 'cash-back': JournalAccount
  readonly 'game-reward': JournalAccount
  readonly hardfork: JournalAccount
  readonly mining: JournalAccount
  readonly 'staking-reward': JournalAccount
  readonly interest: JournalAccount
  readonly 'derivative-profit': JournalAccount
  readonly 'liquidation-profit': JournalAccount
  readonly 'realize-profit': JournalAccount
  readonly 'trade-crypto-pl': JournalAccount
  readonly 'trade-payment-instrument-pl': JournalAccount
  readonly 'trade-nft-pl': JournalAccount
  readonly 'trade-pl': JournalAccount
  readonly 'appraisal-pl': JournalAccount
}
